(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('QuoteSplitDialogController', QuoteSplitDialogController);

    QuoteSplitDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'QuoteSplit', 'Quote', 'Principal'];

    function QuoteSplitDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, QuoteSplit, Quote, Principal) {
        var vm = this;

        vm.isVC = Principal.hasAnyAuthority([/^ROLE_(ADMIN|VC|CUSTOMER_CARE).*/]);
        vm.quoteSplit = entity;
        vm.invoicingEnabled = entity.invoicingEnabled || false;
        vm.originatorAmountInvalid = originatorAmountInvalid;
        vm.adjustmentReasonNotSelected = adjustmentReasonNotSelected;

        vm.adjustmentReasonEnums = [
            { label: 'EFT', value: "ELECTRONIC_FUNDS_TRANSFER" },
            { label: 'Progress Order', value: "PROGRESS_ORDER" },
        ]

        var showInvoiceTab = vm.invoicingEnabled || vm.isVC;
        var showAdjustmentTab = vm.isVC;

        vm.invoiceTabIndex = showInvoiceTab ? 3 : -1;
        vm.adjustmentTabIndex = showAdjustmentTab ? (showInvoiceTab ? 4 : 3) : -1;

        if (vm.quoteSplit.adjustmentReason === 'INVOICE' && vm.invoiceTabIndex >= 0) {
            vm.selectedTab = vm.invoiceTabIndex;
        } else if (vm.quoteSplit.adjustmentReason !== undefined && vm.adjustmentTabIndex >= 0) {
            vm.selectedTab = vm.adjustmentTabIndex;
        } else if (vm.quoteSplit.originatorAmount === 0) {
            vm.selectedTab = 0;
        } else if (vm.quoteSplit.originatorAmount === vm.quoteSplit.totalAmount) {
            vm.selectedTab = 1;
        } else {
            vm.selectedTab = 2;
        }

        vm.clear = clear;
        vm.save = save;

        function originatorAmountInvalid() {
            return vm.quoteSplit.originatorAmount && (vm.quoteSplit.originatorAmount < 0 || vm.quoteSplit.originatorAmount > vm.quoteSplit.totalAmount);
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            var selectedTabTitle = "";

            if (vm.selectedTab === 0) {
                vm.quoteSplit.originatorAmount = 0;
                vm.quoteSplit.adjustmentReason = undefined;
                selectedTabTitle = "Client to Pay";
            } else if (vm.selectedTab === 1) {
                vm.quoteSplit.originatorAmount = vm.quoteSplit.totalAmount;
                vm.quoteSplit.adjustmentReason = undefined;
                selectedTabTitle = "Brokerage to Pay";
            } else if (vm.selectedTab === 2) {
                vm.quoteSplit.adjustmentReason = undefined;
                selectedTabTitle = "Client And Brokerage to Pay";
            } else if (vm.selectedTab === vm.invoiceTabIndex) {
                vm.quoteSplit.originatorAmount = vm.quoteSplit.totalAmount;
                vm.quoteSplit.adjustmentReason = "INVOICE";
                selectedTabTitle = "Invoice";
            } else if (vm.selectedTab === vm.adjustmentTabIndex) {
                selectedTabTitle = "Adjustment";
            }

            gtag("event", "quote_split_saved", {split_selected: selectedTabTitle});

            QuoteSplit.update({
                quoteId: vm.quoteSplit.quoteId,
                originatorAmount: vm.quoteSplit.originatorAmount,
                clientContact: vm.quoteSplit.clientContact,
                adjustmentReason: vm.quoteSplit.adjustmentReason
            }, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('valueconnectApp:quoteSplitUpdate', result.originatorSplit);
            $uibModalInstance.close(result.originatorSplit);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function adjustmentReasonNotSelected() {
            return vm.selectedTab === vm.adjustmentTabIndex && vm.quoteSplit.adjustmentReason === undefined;
        }

    }
})();
